"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexedDB = void 0;
const SEPARATOR = '|';
class IndexedDB {
    constructor(namespace) {
        if (!IndexedDB.indexedDBIsOpen) {
            throw new Error('The IndexedDB needs to be configured, please call the method "setup" before. "await IndexedDBs.setup()"');
        }
        this.setNamespace(namespace);
    }
    static async setup(databaseName) {
        this.indexedDBIsOpen = await this.openConnection(databaseName);
    }
    async get(key) {
        return new Promise((resolve, reject) => {
            const transaction = IndexedDB.db.transaction([IndexedDB.storeName]);
            const store = transaction.objectStore(IndexedDB.storeName);
            const request = store.get(this.getKey(key));
            request.addEventListener('error', (e) => {
                reject(`Error getting cached data ${key}: ${e}`);
            });
            request.addEventListener('success', async () => {
                if (request.result) {
                    const { result } = request;
                    const { value, expiration } = JSON.parse(result);
                    if (new Date(expiration) <= new Date()) {
                        await this.flush(key);
                        resolve(undefined);
                    }
                    resolve(value);
                }
                resolve(null);
            });
        });
    }
    async set(key, data, cacheTTLMs = 20000) {
        return new Promise((resolve, reject) => {
            const transaction = IndexedDB.db.transaction([IndexedDB.storeName], 'readwrite');
            const store = transaction.objectStore(IndexedDB.storeName);
            const request = store.put(this.createPersistable(data, cacheTTLMs), this.getKey(key));
            request.addEventListener('error', (e) => {
                reject(`Failed to store data cache: ${e}`);
            });
            request.addEventListener('success', () => {
                resolve();
            });
        });
    }
    async flush(key) {
        return new Promise((resolve, reject) => {
            const transaction = IndexedDB.db.transaction([IndexedDB.storeName], 'readwrite');
            const store = transaction.objectStore(IndexedDB.storeName);
            const request = store.delete(this.getKey(key));
            request.addEventListener('error', (e) => {
                reject(`Failed to flush cache: ${e}`);
            });
            request.addEventListener('success', () => {
                resolve();
            });
        });
    }
    getKey(key) {
        return this.namespace ? `${this.namespace}${SEPARATOR}${key}` : key;
    }
    createPersistable(data, cacheTTLMs) {
        const expiration = new Date().getTime() + cacheTTLMs;
        return JSON.stringify({ value: data, expiration });
    }
    setNamespace(namespace) {
        if (namespace.includes(SEPARATOR)) {
            throw new Error(`Namespace cannot contain the "${SEPARATOR}" character.`);
        }
        this.namespace = namespace;
    }
    static openConnection(databaseName) {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(databaseName, 1);
            request.onsuccess = () => {
                this.db = request.result;
                resolve(true);
            };
            request.onupgradeneeded = (event) => {
                const db = request.result;
                if (db.objectStoreNames.contains(this.storeName)) {
                    console.log(`Clearing out version ${event.oldVersion} cache`);
                    db.deleteObjectStore(this.storeName);
                }
                console.log(`Creating version ${event.newVersion} cache`);
                db.createObjectStore(this.storeName);
            };
            request.onblocked = reject;
            request.onerror = reject;
        });
    }
}
exports.IndexedDB = IndexedDB;
IndexedDB.storeName = 'CacheStore';
